<template lang="pug">
section#company-view.pt0
  #company-view-content(flex="row justify-start wrap")
    .grid(v-for="company in companies")
      item(
        ':link'="company | socialCompanyDetailUrl | slug"
        ':title'="company.name.en"
        ':full-text'="true",
        ':mobile-list'="true",
        ':image'="company.thumbnail_image | resource"
        )
</template>

<script>
import axios from 'axios'
import Item from './../../item.vue'


export default {
  data () {
    return {
      companies: [],
    }
  },
  created () {
    axios.get('/api/social_companies', {
      params: {
        hits: 1000
      }
    })
    .then((response) => {
      if (_.has(response.data, 'results')) {
        this.companies = response.data.results
      }
    })
  },
  ready () {
  },
  attached () {},
  methods : {
  },
  components: {
    item: Item,
  }
}
</script>

<style lang="scss">
@import "global";
@media (max-width: $grid-float-breakpoint-max) {
  .grid {
    a.block {
      display: flex;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "global";
@media (max-width: $grid-float-breakpoint-max) {
  section {
    &:last-child {
      padding-bottom: 16px;
    }
  }
}
#company-view-content {
  padding-bottom: 80px;
  padding-top: 58px;
  @media(max-width: $grid-float-breakpoint-max) {
    padding-top: 0;
  }
}
.container:before {
  content: none;
}
.grid {
  width: 25%;
}

@media (max-width: $grid-float-breakpoint-max) {
  .grid {
    width: 100%;
    border-bottom: 1px solid $gray-lighter;
  }
  #company-view-content {
    margin-top: $responsive-mdl-selector-height + 2px;
  }
}
</style>



// WEBPACK FOOTER //
// company-list.vue?013aba0f